<div 
  class="min-h-screen flex items-center justify-center px-4 py-12 relative"
  [style.background-image]="'url(' + bannerImage() + ')'"
  style="background-size: cover; background-position: center; background-repeat: no-repeat;"
>
  <!-- Dark Overlay for Contrast -->
  <div class="absolute inset-0 bg-black/60 z-0"></div>
  
  <!-- Content -->
  <div class="relative z-10 w-full max-w-md">
    <nz-card [nzBordered]="false" class="!bg-white/95 backdrop-blur-sm shadow-2xl">
      <div class="text-center mb-6">
        <h2 class="text-2xl font-bold text-gray-900">Login</h2>
        <p *ngIf="step() === 'membership'" class="text-sm text-gray-600 mt-2">
          Enter your HAC membership number and we'll send you an OTP to authenticate
        </p>
      </div>

      <!-- Membership Number Step -->
      <form
        *ngIf="step() === 'membership'"
        [formGroup]="membershipForm"
        (ngSubmit)="onMembershipSubmit()"
        class="space-y-6"
      >
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>HAC Membership Number</nz-form-label>
          <nz-form-control
            nzErrorTip="Please enter your HAC membership number"
            [nzSpan]="24"
          >
            <input
              nz-input
              nzSize="large"
              formControlName="hacMemberNumber"
              type="text"
              placeholder="Enter your HAC membership number"
            />
          </nz-form-control>
        </nz-form-item>

        <button
          nz-button
          nzType="primary"
          nzSize="large"
          nzBlock
          [nzLoading]="loading()"
          type="submit"
        >
          Send OTP
        </button>
      </form>

      <!-- OTP Step -->
      <form
        *ngIf="step() === 'otp'"
        [formGroup]="otpForm"
        (ngSubmit)="onOtpSubmit()"
        class="space-y-6"
      >
        <div class="text-center mb-4">
          <p class="text-sm text-gray-600">
            We've sent a verification code to the email associated with membership number
          </p>
          <p class="text-sm font-semibold text-gray-900 mt-1">{{ membershipNumber() }}</p>
        </div>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>OTP Code</nz-form-label>
          <nz-form-control
            nzErrorTip="Please enter the OTP code"
            [nzSpan]="24"
          >
            <input
              nz-input
              nzSize="large"
              formControlName="otp"
              type="text"
              placeholder="Enter OTP code"
              maxlength="6"
            />
          </nz-form-control>
        </nz-form-item>

        <div class="flex gap-3">
          <button
            nz-button
            nzType="default"
            nzSize="large"
            (click)="goBack()"
            [disabled]="loading()"
            class="flex-1"
          >
            Back
          </button>
          <button
            nz-button
            nzType="primary"
            nzSize="large"
            [nzLoading]="loading()"
            type="submit"
            class="flex-1"
          >
            Verify OTP
          </button>
        </div>
      </form>
    </nz-card>
  </div>
</div>

